import { useWizardStep } from '@apply/components';
import { useStandardLoanStore } from '../../../../state/standardLoanStore';
import { getLoanProgress } from './LoanInfo/functions/getLoanProgress';
import { LoanInfo } from './LoanInfo/LoanInfo';
import { LoanFiles } from './LoanFiles/LoanFiles';

/**
 * The "Loan" step. Enables Save & Continue once every currently-required field is complete.
 */
export const Loan = () => {
    const loan = useStandardLoanStore((state) => state.loan);
    const setup = useStandardLoanStore((state) => state.setup);

    const { numberComplete, total } = getLoanProgress(loan, setup);
    useWizardStep({ enableSaveAndContinue: numberComplete === total });

    return (
        <>
            <LoanInfo />
            <LoanFiles />
        </>
    );
};
